import React from "react";
import DocumentUploadField from "../elements/document-upload-field";

export default function ExcuseDuty(props: any) {
  return (
    <DocumentUploadField
      title="Excuse duty document"
      onUploaded={props.setExcuseDuty}
    />
  );
}
